module.exports = __webpack_public_path__ + "media/images/home-hero-d7217e6f4fe4ddbead956dec6f8be781d9f5c96d82e2408389f0bde94caf4050.jpg";